import { proceedOnEstimateConstants } from '../constants/actionTypes'

const initialState = {
  errorMsgOnProceedEstimate: '',
  isSubmitting: false,
  hasSubmissionFailed: false,
  estimateSubmittedForOpportunity: false, // Check and update this status when the consultant data is fetched
  errorMsgOnCancelProceedEstimate: '',
  hasCancelSubmissionFailed: false,
  cancellationSubmittedForProceededEstimate: false,
  isCancelRequestSubmitting: false,
}

export default function proceedEstimateReducer(state = initialState, action) {
  switch (action.type) {
    case proceedOnEstimateConstants.PROCEED_ESTIMATE_SUCCESS:
      return {
        ...state,
        errorMsgOnProceedEstimate: '',
        isSubmitting: false,
        hasSubmissionFailed: false,
        estimateSubmittedForOpportunity: true,
        cancellationSubmittedForProceededEstimate: false,
      }
    case proceedOnEstimateConstants.PROCEED_ESTIMATE_FAILED:
      return {
        ...state,
        errorMsgOnProceedEstimate: action.payload, // error message from service response
        isSubmitting: false,
        hasSubmissionFailed: true,
        estimateSubmittedForOpportunity: false,
      }
    case proceedOnEstimateConstants.PROCEED_ESTIMATE_SUBMITTING:
      return {
        ...state,
        errorMsgOnProceedEstimate: '',
        isSubmitting: true,
        hasSubmissionFailed: false,
        estimateSubmittedForOpportunity: false,
      }
    case proceedOnEstimateConstants.CANCEL_PROCEED_ESTIMATE_SUCCESS:
      return {
        ...state,
        errorMsgOnCancelProceedEstimate: '',
        hasCancelSubmissionFailed: false,
        cancellationSubmittedForProceededEstimate: true,
        isCancelRequestSubmitting: false,
      }
    case proceedOnEstimateConstants.CANCEL_PROCEED_ESTIMATE_FAILED:
      return {
        ...state,
        errorMsgOnCancelProceedEstimate: action.payload,
        hasCancelSubmissionFailed: true,
        cancellationSubmittedForProceededEstimate: false,
        isCancelRequestSubmitting: false,
      }
    case proceedOnEstimateConstants.CANCEL_PROCEED_ESTIMATE_SUBMITTING:
      return {
        ...state,
        errorMsgOnCancelProceedEstimate: '',
        hasCancelSubmissionFailed: false,
        cancellationSubmittedForProceededEstimate: false,
        isCancelRequestSubmitting: true,
      }
    case proceedOnEstimateConstants.RESET_PROCEED_ESTIMATE_ERROR_MESSAGE:
      return {
        ...state,
        errorMsgOnCancelProceedEstimate: '',
        hasCancelSubmissionFailed: false,
        errorMsgOnProceedEstimate: '',
        hasSubmissionFailed: false,
      }
    default:
      return state
  }
}
